export default "__VITE_ASSET__DkNhYYtr__"